import { FolderOpen, Globe, Users } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

/**
 * The three places a record can live, as one switch. Grouping them here rather
 * than in the masthead keeps the top navigation about sections of the product
 * and this about which pool of records you are looking at.
 */
const TABS = [
  { to: '/database', label: 'Public Database', icon: Globe },
  { to: '/workspace', label: 'My Workspace', icon: FolderOpen },
  { to: '/projects', label: 'Projects', icon: Users },
]

export function SectionTabs({ note }: { note?: string }) {
  return (
    <div className="flex items-center gap-3 pb-5">
      <nav className="flex gap-1.5">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 rounded-[var(--radius-control)] border px-3 py-1.5 text-[13px] font-medium transition-colors',
                isActive
                  ? 'border-brand-line bg-brand-soft text-brand'
                  : 'border-line bg-paper text-ink-soft hover:bg-paper-muted',
              )
            }
          >
            <tab.icon className="size-4" />
            {tab.label}
          </NavLink>
        ))}
      </nav>

      {note && <span className="text-[12px] text-ink-muted">{note}</span>}
    </div>
  )
}
